/**
 * Texts for Training page
 */
export const trainingPageText = {
    title: 'Schulung - CamAPS FX',
    titleMeta: 'Wir bieten kostenlose Online-Schulungen für CamAPS FX-Benutzer',
    descriptionMeta: 'Das Diabetes-Ausbildungsprogramm von Cambridge bietet eine kostenlose zertifizierte Online-Schulung für Menschen mit Typ-1-Diabetes, Eltern und Erziehungsberechtigte, Schulpersonal und medizinisches Fachpersonal.',
    keywords: 'camaps schulung, camaps fx training,  camaps training, camaps fx schulung,  ',
    localeMeta: 'de_de',
    mainHeader: 'Gesundheitspersonaltraining',
    mainSubHeader: 'Unterstützen Sie Menschen, die CamAPS FX verwenden, mit von Experten geleiteten Schulungen.',
    gettingStartedHeader: 'Erste Schritte',
    step1Title: '<strong>Schritt 1:</strong><br/>Laden Sie die App herunter',
    step2Title: '<strong>Schritt 2:</strong><br/>Erstellen Sie ein Konto',
    step3Title: '<strong>Schritt 3:</strong><br/>Beginnen Sie mit der wichtigen In-App-Schulung',
    step4Title: '<strong>Schritt 4:</strong><br/>Koppeln Sie Ihre gewählte Pumpe und CGM (mit Zustimmung Ihres medizinischen Teams) oder erkunden Sie die App im <strong>virtuellen Modus</strong>',
    videoSrc: '/video/In-app training loop_1.mp4',
    certifiedTrainingTitle: 'Zertifiziertes Training',
    trainingHeader: 'Zertifiziertes Training',
    trainingHeader_2: 'Für medizinisches Fachpersonal',
    trainingHeader_3: 'Benutzerschulung',
    trainingHeaderText: 'KOSTENLOSES online CamAPS FX Training des Cambridge Diabetes Education Programme (CDEP).',
    websiteLink: 'https://www.camdiabtraining.com/account-sign-in.html',
    websiteLinkHeading: 'CDEP Training',
    getTrained: 'Zum Training',
    trainingHeaderIat: 'CamAPS FX Training',
    trainingHeaderTextIat: 'Schließen Sie das wesentliche In-App-Training ab, bevor Sie die CamAPS FX-App verwenden.',
    trainingSubHeaderOneIat: 'Erste Schritte',
    trainingSubTextOneIat: 'Laden Sie die CamAPS FX-App herunter. <br>Erstellen Sie ein Konto, um mit dem Training zu beginnen.',
    trainingSubHeaderTwoIat: 'Brauchen Sie Hilfe bei der Installation der App?',
    trainingParaTwoStartIat: 'Besuchen Sie unseren',
    trainingParaTwoEndIat: 'Bereich für Anleitungen.',
    websiteLinkHeadingSupportIat: 'Support',
    trainingSubHeaderThreeIat: 'Weitere Ressourcen',
    animationsYpsoPumpText: 'Animationen',
    animationsAndText: 'und',
    animationsDanaText: 'Animationen (Dana-Pumpe)',
    animationsFurtherText: 'Lernen Sie anhand von Schritt-für-Schritt-Visualisierungen.',
    webinarsText: 'Webinare',
    webinarsFurtherText: 'Sehen Sie sich von Experten geleitete Sitzungen zur Nutzung der App an.',
    websiteAnimationsYpsoPumpLink: 'https://www.camdiabtraining.com/view/27/mylife-YpsoPump-users.htm',
    websiteAnimationsDanaLink: 'https://www.camdiabtraining.com/view/25/Dana-insulin-pump-users.htm',
    websiteWebinarsLink: 'https://www.camdiabtraining.com/view/20/Webinars.htm',
};
